import React from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import { Button } from '../ui/button';
import { useApp } from '../../context/AppContext';
import { TESTIMONIALS } from '../../data/constants';

export const Testimonials = () => {
  const { t, lang } = useApp();
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="landing-testimonials-section">
      <h2 className="text-3xl md:text-4xl font-black tracking-tight text-[#1A1A1A] text-center">{t('testim.title')}</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
        {TESTIMONIALS.map((tm) => (
          <div key={tm.id} className="bg-white rounded-2xl p-6 border border-[#EFEAE0] hover:shadow-lg transition-shadow">
            <div className="flex gap-0.5 mb-3">
              {Array.from({ length: tm.rating }, (_, j) => <Star key={`${tm.id}-star-${j}`} className="w-4 h-4 fill-[#F2B441] text-[#F2B441]" />)}
            </div>
            <p className="text-[#1A1A1A] leading-relaxed text-sm">« {tm.text[lang] || tm.text.en} »</p>
            <div className="flex items-center gap-3 mt-5 pt-5 border-t border-[#F5F1E8]">
              <div className="w-10 h-10 rounded-full bg-[#0F8B5C] flex items-center justify-center text-white font-bold text-sm">{tm.avatar}</div>
              <div>
                <div className="font-semibold text-sm text-[#1A1A1A]">{tm.name}</div>
                <div className="text-xs text-[#7A7468]">{tm.location}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export const CtaBanner = () => {
  const { t } = useApp();
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20" data-testid="landing-cta-section">
      <div className="relative overflow-hidden bg-[#1A1A1A] rounded-3xl p-10 md:p-16 text-center">
        <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-[#F2B441]/20 blur-3xl" />
        <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full bg-[#0F8B5C]/30 blur-3xl" />
        <div className="relative">
          <h2 className="text-3xl md:text-5xl font-black tracking-tight text-white max-w-3xl mx-auto leading-tight">{t('cta.title')}</h2>
          <p className="mt-4 text-lg text-white/70 max-w-xl mx-auto">{t('cta.subtitle')}</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/signin"><Button size="lg" className="bg-[#F2B441] hover:bg-[#E8A82E] text-[#1A1A1A] font-bold px-8 h-12" data-testid="landing-signup-cta">{t('cta.button')}</Button></Link>
            <Link to="/post"><Button size="lg" variant="outline" className="bg-transparent border-white/30 text-white hover:bg-white/10 hover:text-white px-8 h-12" data-testid="landing-post-cta">{t('nav.post')}</Button></Link>
          </div>
        </div>
      </div>
    </section>
  );
};
